/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React from "react";
import tw, { css, theme } from "twin.macro";
import { useMediaQuery } from "~hooks";

import Grid from "~components/styles/Grid.jsx";
import SwiperCarousel from "~components/SwiperCarousel.jsx";
import * as T from "~components/styles/Typography.jsx";
import Go from "~components/Go.jsx";
import Button from "~components/Button.jsx";

const TextTwoColumn = ({ data }) => {
  const { backgroundColor, textColor, columnOne, columnTwo, button } = data;

  const { isDesktop } = useMediaQuery();

  const columns = [columnOne, columnTwo];

  return (
    <section
      css={[
        css`
          background-color: ${backgroundColor?.hex || `white`};
          color: ${textColor?.hex || `black`};
        `,
        tw`relative block`
      ]}
    >
      <Grid _css={[tw`h-full min-h-inherit`, isDesktop && tw`pt-6 pb-16`]}>
        {isDesktop ? (
          <>
            <div css={[tw`col-start-2 col-span-10`]}>
              <T.Body font="1" _css={[tw`whitespace-pre-line`]}>
                {columnOne}
              </T.Body>
            </div>

            <div css={[tw`hidden md:block col-start-14 col-span-10`]}>
              <T.Body font="1" _css={[tw`whitespace-pre-line`]}>
                {columnTwo}
              </T.Body>
              {button && (
                <Go
                  _css={[tw`w-full md:w-auto mt-12 md:mt-12 block`]}
                  to={button.link}
                >
                  <Button
                    _css={[tw`w-full md:w-auto`]}
                    color="orange-dark"
                    text={button.text}
                    transparent
                  />
                </Go>
              )}
            </div>
          </>
        ) : (
          <>
            <div css={[tw`relative w-full col-span-full py-10`]}>
              <SwiperCarousel
                nav={({ current }) => (
                  <ul
                    css={[
                      tw`w-full relative flex items-center justify-center pt-8`
                    ]}
                  >
                    {columns.map((_, index) => {
                      const key = `colums-text-two-${index}`;

                      return (
                        <li
                          key={key}
                          css={[
                            css`
                              width: 6px;
                              height: 6px;
                              margin: 0 2px;
                              background: ${current === index
                                ? theme`colors.orange-dark`
                                : theme`colors.orange-light`};
                            `,
                            tw`relative block rounded-full`
                          ]}
                        />
                      );
                    })}
                  </ul>
                )}
                slides={columns.map((column, index) => {
                  const key = `text-column-${index}`;

                  return (
                    <div key={key}>
                      <T.Body font="1">{column}</T.Body>
                    </div>
                  );
                })}
                options={{ spaceBetween: 20 }}
              />

              {button && (
                <Go
                  _css={[tw`w-full md:w-auto mt-12 md:mt-12 block`]}
                  to={button.link}
                >
                  <Button
                    _css={[tw`w-full md:w-auto`]}
                    color="orange-dark"
                    text={button.text}
                    transparent
                  />
                </Go>
              )}
            </div>
          </>
        )}
      </Grid>
    </section>
  );
};

export default TextTwoColumn;
